import React, { Component } from 'react';
import { Button, Card, message, Image, Modal, Spin, Tabs } from 'antd';
import { connect } from 'react-redux';
import { addBreadcrumber, reduceBreadcrumber, replaceBreadcrumber } from '../../redux/actions/Breadcrumber';
import axios from 'axios';
import baseConfig from '../../config/BaseConfig';
import './CreateAssess.less';
import AssessData from '../../config/Assess';
import { ClockCircleOutlined } from '@ant-design/icons';
import { ROLE_STUDENT } from '../../config/constant';
import { formatHourMinuteSecond } from '../../config/Common';

/* 创建测评 */
class CreateAssess extends Component {

    iframeRef = React.createRef();

    iframeUrl = '';
    // 目录数据
    menuData = [];
    // 目录一级菜单key
    menuSubMenuKeys = [];
    // 
    defaultCourseIds = [];
    // 测评项目
    assessItems = []

    constructor(props) {
        super(props);

        let user_id = this.props.loginData.role == ROLE_STUDENT ? this.props.loginData.user_id : props.location.state.id;

        this.state = {
            courseId: '',
            itemTitle: '',
            reportType: '',
            itemImage: 'error',
            itemDescribe: '',
            itemTime: '',
            itemNotes: '',
            userId: user_id,
            url: '',
            stopModalText: '',
            selectItemUrl: '',
            mainModalVisible: false,
            stopModalVisible: false,
            endModalVisible: false,
            tipsOneModalVisible: false,
            tipsTwoModalVisible: false,
            tipsThreeModalVisible: false,
            tipsThreeDownloadUrl: '',
            tipsText: '',
            tipsTitle: '提示',
            mainModalWidth: '1300px',
            mainModalHeight: '765px',
            iframeHeight: '710px',
            reportId: '',
            cocosLoading: false,
            unityLoading: false,
            assessName3D: '',
            assessUrl3D: '',
            tipsModalType: '',
            tabsDom: <></>,

            rechargeModalVisible: false,
            rechargeModalMsg: '',
            isStuType: this.props.loginData.role == ROLE_STUDENT ? true : false,

            assessRemainder: 0,
            assessRemainderText: '',
            assessRemainderVisible: false,
            assessTimerId: 0,

            // 系统时间戳
            startTimeStamp: 0,
            totalTime: 0,

        };

        for (let i = 0; i < AssessData.length; i++) {
            this.menuSubMenuKeys.push(AssessData[i].key);
            if (i == 0) {
                this.defaultCourseIds.push(AssessData[i].children[0].key);
            }
        }
    }

    // 组件挂载
    componentDidMount() {
        this.courseItem();
    }

    // 课程菜单
    courseItem = () => {
        this.assessItems.length = 0;
        axios.get(baseConfig.httpUrl + `/api/training/course-list`, { params: { user_id: this.state.userId } }).then(
            response => {
                if (response.data.res == 1) {

                    let tempArr = [...response.data.list];
                    let tabPanes = [];

                    for (let i = 0; i < tempArr.length; i++) {

                        if (this.checkCourseId(tempArr[i].course_id.toString())) {
                            this.setState({ assessName3D: tempArr[i].name, assessUrl3D: tempArr[i].url });
                        }

                        let tebPanesType = true;
                        tabPanes.forEach(item => {
                            if (item.category_id == tempArr[i].category_id) {
                                tebPanesType = false;
                            }
                        });

                        if (tebPanesType) {
                            tabPanes.push({ category_id: tempArr[i].category_id, category_name: tempArr[i].category_name, child: [] });
                        }


                        tabPanes.forEach(item => {
                            if (item.category_id == tempArr[i].category_id) {
                                item.child.push(tempArr[i]);
                            }
                        });
                    }

                    let tabPanesDome = [];

                    tabPanes.forEach(item => {

                        let childDome = [];
                        item.child.forEach(elm => {

                            let buttonDom = <></>
                            // 登录人是否是学生
                            if (this.state.isStuType) {
                                // 课程是否可以进入
                                if (elm.can_enter) {
                                    buttonDom = <Button shape="round" className='createAssess-item-startBtn' htmlType='button' type='primary' onClick={this.startAssess(elm.name, elm.course_id, elm.url, elm.report_type, this.state.userId, elm)}>开启测评</Button>
                                }
                                else {
                                    // 课程是否可以查看报告
                                    if (elm.can_visit_report) {
                                        buttonDom = <Button shape="round" className='createAssess-item-startBtn' htmlType='button' type='primary' onClick={() => { this.viewReport(elm) }}>查看报告</Button>
                                    }
                                    else {
                                        buttonDom = <Button shape="round" className='createAssess-item-startBtn' htmlType='button' disabled={true} type='primary'>开启测评</Button>
                                    }
                                }
                            }
                            else {
                                buttonDom = <Button shape="round" className='createAssess-item-startBtn' htmlType='button' disabled={elm.can_enter == 1 ? false : true} type='primary' onClick={this.startAssess(elm.name, elm.course_id, elm.url, elm.report_type, this.state.userId, elm)}>开启测评</Button>
                            }


                            childDome.push(
                                <div className='createAssess-item' key={elm.course_id}>
                                    <Image
                                        className='createAssess-item-image'
                                        src={elm.image}
                                        preview={false}
                                        fallback="data:image/png;base64,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"
                                    />
                                    <p className='createAssess-item-name'>{elm.name}</p>
                                    <div className='createAssess-item-time'>
                                        <ClockCircleOutlined className='createAssess-item-icon' />
                                        <p className='createAssess-item-timeText'>测评时间：{elm.time}</p>
                                    </div>
                                    <div className='createAssess-item-text' title={elm.description}>{elm.description}</div>
                                    <div className='createAssess-item-bottom'>
                                        {/* <Button shape="round" className='createAssess-item-startBtn' htmlType='button' disabled={elm.can_enter == 1 ? false : true} type='primary' onClick={this.startAssess(elm.name, elm.course_id, elm.url, elm.report_type, this.state.userId, elm)}>开启测评</Button> */}
                                        {buttonDom}
                                    </div>
                                </div>
                            );
                        })

                        tabPanesDome.push(
                            <Tabs.TabPane tab={item.category_name} key={item.category_id}>
                                <div>
                                    {[...childDome]}
                                </div>
                            </Tabs.TabPane>
                        );
                    });

                    let tempDome = < Tabs defaultActiveKey={tabPanes[0].category_id} >
                        {[...tabPanesDome]}
                    </Tabs >

                    this.setState({ tabsDom: tempDome });
                }
                else {
                    message.error(response.data.msg);
                }
            }
        )
    }

    // 开始测评
    startAssess = (assessName, assessCourseId, assessUrl, report_type, userId, assessData) => {
        return () => {
            // 是否是BCI项目 需要token
            if (assessData.use_token) {
                axios.get(baseConfig.httpUrl + `/api/user/get-login-token`, {}).then(
                    response => {
                        if (response.data.res == 1) {
                            this.setState({ assessToken: response.data.token, assessUseToken: assessData.use_token })
                            this.checkMoney(assessName, assessCourseId, assessUrl, report_type, userId)
                        }
                        else {
                            message.error(response.data.msg)
                        }
                    }
                )
            }
            else {
                this.checkMoney(assessName, assessCourseId, assessUrl, report_type, userId)
            }
        }
    }

    /**
     * 查询余额
     * @param {*} assessName 
     * @param {*} assessCourseId 
     * @param {*} assessUrl 
     * @param {*} report_type 
     * @param {*} userId 
     */
    checkMoney = (assessName, assessCourseId, assessUrl, report_type, userId) => {
        axios.get(baseConfig.httpUrl + `/api/training/check-money`, { params: { course_id: assessCourseId, user_id: userId } }).then(
            response => {
                if (response.data.res == 1) {

                    //监听message事件
                    window.addEventListener("message", this.receiveMessageFromIframe);
                    this.iframeUrl = assessUrl + '?t=' + new Date().getTime();
                    // console.log('查询余额')
                    // this.countdownTimer(10);
                    this.setState({
                        mainModalVisible: true,
                        itemTitle: assessName,
                        courseId: assessCourseId,
                        reportType: report_type,
                        mainModalWidth: this.checkCourseId(assessCourseId) ? '1300px' : '1100px',
                        mainModalHeight: this.checkCourseId(assessCourseId) ? '765px' : '765px',
                        iframeHeight: this.checkCourseId(assessCourseId) ? '710px' : '710px',
                        cocosLoading: this.checkCourseId(assessCourseId) ? false : true,
                        unityLoading: this.checkCourseId(assessCourseId) ? false : true,
                    });
                }
                else {
                    this.setState({ rechargeModalVisible: true, rechargeModalMsg: response.data.msg });
                }
            }
        );
    }

    /**
     * 检查课程id
     * @param {*} assessCourseId 
     * @returns 
     */
    checkCourseId = (assessCourseId) => {
        return assessCourseId.toString() == '30000002' || assessCourseId.toString() == '30000007' || assessCourseId.toString() == '30000008'
    }

    // 开始测评
    startAssessCall = (assessName, assessCourseId, assessUrl, assessReportType) => {
        // console.log('开始测评')
        //监听message事件
        window.addEventListener("message", this.receiveMessageFromIframe);
        this.iframeUrl = assessUrl + '?t=' + new Date().getTime();
        this.setState({
            mainModalVisible: true,
            itemTitle: assessName,
            courseId: assessCourseId,
            reportType: assessReportType,
            mainModalWidth: this.checkCourseId(assessCourseId) ? '1300px' : '1100px',
            mainModalHeight: this.checkCourseId(assessCourseId) ? '765px' : '765px',
            iframeHeight: this.checkCourseId(assessCourseId) ? '710px' : '710px',
            cocosLoading: this.checkCourseId(assessCourseId) ? false : true,
            unityLoading: this.checkCourseId(assessCourseId) ? false : true,
            tipsModalType: '',
            tipsText: '',
            tipsTitle: '',
            tipsTwoModalVisible: false,
        });
    }

    // 检查余额
    checkBalance = (courseId) => {
        axios.get(baseConfig.httpUrl + `/api/training/check-money`, { params: { course_id: courseId } }).then(
            response => {
                if (response.data.res == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }
        );
    }

    // 点击右上角-关闭测评
    assessClose = () => {
        const iframeDom = this.iframeRef.current;
        iframeDom.contentWindow.postMessage({
            from: 'createAssess',
            type: 'stopAssess'
        }, '*');
        this.courseItem()
        // this.setState({ assessRemainderVisible: false, assessRemainderText: '', assessRemainder: 0 });
        // clearInterval(this.state.assessTimerId)
    }

    // 接收iframes调用
    receiveMessageFromIframe = (event) => {
        if (event !== undefined && event.data.from == 'gamemain') {
            console.log('我是react,我接受到了来自iframe的模型ID：', event.data);

            if (event.data.type == 'assessEnd') {
                this.setState({ tipsModalType: '', stopModalVisible: false, endModalVisible: true });
            }
            else if (event.data.type == 'assessItemEnd') {
                this.setState({ reportId: event.data.guid });
            }
            else if (event.data.type == 'assess3DEnd') {
                this.setState({ tipsModalType: '', stopModalVisible: false, endModalVisible: true, reportId: event.data.guid });
            }
            else if (event.data.type == 'assessStatus') {
                if (event.data.value == 1) {
                    this.stopEvaluate();
                }
                else {
                    this.stopOk();
                }
            }
            else if (event.data.type == 'tipsStatus') {
                if (event.data.ty == 1) {
                    if (event.data.text == 'load_end') {
                        this.setState({ cocosLoading: true });
                    }
                    else {
                        this.setState({ tipsModalType: '', tipsText: event.data.text, tipsOneModalVisible: event.data.flag });
                    }
                }
                else if (event.data.ty == 2) {
                    this.setState({ tipsModalType: '', tipsText: event.data.text, tipsTitle: event.data.title, tipsTwoModalVisible: event.data.flag });
                }
                else if (event.data.ty == 3) {
                    this.setState({ tipsModalType: '', tipsText: event.data.text, tipsTitle: event.data.title, tipsThreeModalVisible: event.data.flag, tipsThreeDownloadUrl: event.data.culinkUrl });
                }
            }
            else if (event.data.type == 'gamebreak') {
                this.stopOk();
                this.setState({ tipsModalType: 'gamebreak', tipsText: '检测到脑波仪未正确佩戴，测评已中止，请调整脑波仪佩戴状态，然后重新开始测评', tipsTitle: '测评已中止', tipsTwoModalVisible: true });
            }
            else if (event.data.type == 'unityLoading') {
                this.setState({ unityLoading: true });
            }
            else if (event.data.type == 'remainder') {
                let assessRemainderNum = event.data.value ? event.data.value : 0
                this.countdownTimer(assessRemainderNum)
            }
            else if (event.data.type == 'startTiming') {
                let assessRemainderNum = event.data.value ? event.data.value : 0
                this.countdownTimer(assessRemainderNum)
            }
            else if (event.data.type == 'getPenguinRemainder') {
                const iframeDom = this.iframeRef.current;
                iframeDom.contentWindow.postMessage({
                    from: 'createAssess',
                    type: 'penguinRemainder',
                    value: this.state.assessRemainder
                }, '*');
            }
            else if (event.data.type == 'stopPenguinRemainder') {
                clearInterval(this.state.assessTimerId)
            }
        }
    }

    // 主动停止前提示
    stopEvaluate = () => {
        this.setState({
            stopModalVisible: true,
            stopModalText: '正在测评中，您确认要停止测评吗？如停止测评将不会生成测评报告！未完成的测评项目需要重新进行测评！',
        });
    }

    // 主动停止前提示-ok
    stopOk = () => {
        // 移除监听
        window.removeEventListener("message", this.receiveMessageFromIframe);
        this.iframeRef.current.setAttribute('src', 'about:blank');
        this.iframeUrl = 'about:blank';
        this.setState({ stopModalVisible: false, mainModalVisible: false, assessRemainderVisible: false, assessRemainderText: '', assessRemainder: 0 });
        // this.setState({ assessRemainderVisible: false, assessRemainderText: '', assessRemainder: 0 });
        clearInterval(this.state.assessTimerId)
    }

    // 主动停止前提示-c
    stopClose = () => {
        this.setState({ stopModalVisible: false });
    }

    // 关闭弹框-测评结束
    evaluateClose = () => {
        this.courseItem();
        this.jumpAssessor();
    }

    // 查看报告
    jumpReports = () => {
        this.courseItem();

        // 移除监听
        window.removeEventListener("message", this.receiveMessageFromIframe);
        this.iframeRef.current.setAttribute('src', 'about:blank');
        this.iframeUrl = 'about:blank';
        this.setState({ endModalVisible: false, mainModalVisible: false, assessRemainderText: '', assessRemainder: 0 });
        clearInterval(this.state.assessTimerId)

        // window.open('/penguin/public/index.php/api/report/main?train_result_guid=' + this.state.reportId, '_blank');

        if (this.state.reportType.toString() == '0') {
            window.open('/penguin/public/index.php/api/report/main?train_result_guid=' + this.state.reportId, '_blank');
        }
        else if (this.state.reportType.toString() == '3') {
            window.open('/index.php/Home/Mreport/scaleReport/guid/' + this.state.reportId, '_blank');
        }
        else if (this.state.reportType.toString() == '4') {
            // window.open("https://storage.mind360.com.cn/bg_media/penguin/report/" + this.state.reportId + ".pdf", '_blank');
            window.open(baseConfig.httpUrl + `/api/report/career-report?course_user_guid=` + this.state.reportId, '_blank');
        }
        else if (this.state.reportType.toString() == '5' || this.state.reportType.toString() == '6') {
            window.open('/index.php/Home/Mreport/attentionReportNoEEG/guid/' + this.state.reportId, '_blank');
        }
        else if (this.state.reportType.toString() == '9') {
            window.open('/penguin/public/index.php/api/report/hypnosis-report?course_user_guid=' + this.state.reportId, '_blank');
        }
        else if (this.state.reportType.toString() == '10') {
            window.open('/penguin/public/index.php/api/report/dong-tai-te-shu-jiao-yu?course_user_guid=' + this.state.reportId, '_blank');
        }
        else {
            window.open('/index.php/Home/Mreport/attentionReport/guid/' + this.state.reportId, '_blank');
        }
        // else if (this.state.reportType.toString() == '2') {
        //     window.open('/index.php/Home/Mreport/attentionReport/guid/' + this.state.reportId, '_blank');
        // }
    }

    /**
     * 查看报告
     * @param {*} data 
     */
    viewReport = (data) => {
        // console.log(data)
        if (data.report_type.toString() == '0') {
            window.open('/penguin/public/index.php/api/report/main?train_result_guid=' + data.course_user_guid, '_blank');
        }
        else if (data.report_type.toString() == '3') {
            window.open('/index.php/Home/Mreport/scaleReport/guid/' + data.course_user_guid, '_blank');
        }
        else if (data.report_type.toString() == '4') {
            // window.open("https://storage.mind360.com.cn/bg_media/penguin/report/" + data.course_user_guid + ".pdf", '_blank');
            window.open(baseConfig.httpUrl + `/api/report/career-report?course_user_guid=` + data.course_user_guid, '_blank');
        }
        else if (data.report_type.toString() == '5' || data.report_type.toString() == '6') {
            window.open('/index.php/Home/Mreport/attentionReportNoEEG/guid/' + data.course_user_guid, '_blank');
        }
        else if (data.report_type.toString() == '9') {
            window.open('/penguin/public/index.php/api/report/hypnosis-report?course_user_guid=' + data.course_user_guid, '_blank');
        }
        else if (data.report_type.toString() == '10') {
            window.open('/penguin/public/index.php/api/report/dong-tai-te-shu-jiao-yu?course_user_guid=' + data.course_user_guid, '_blank');
        }
        else {
            window.open('/index.php/Home/Mreport/attentionReport/guid/' + data.course_user_guid, '_blank');
        }
    }

    // 返回列表
    jumpAssessor = () => {
        this.courseItem();
        // 移除监听
        window.removeEventListener("message", this.receiveMessageFromIframe);
        this.iframeRef.current.setAttribute('src', 'about:blank');
        this.iframeUrl = 'about:blank';
        this.setState({ endModalVisible: false, mainModalVisible: false, assessRemainderText: '', assessRemainder: 0 });
        clearInterval(this.state.assessTimerId)

        if (!this.state.isStuType) {
            this.props.reduce(2);
            this.props.replace([{ path: '/assessmanage', name: '测评管理', grade: 1 }, { path: '/assessormanage', name: '受测者管理', grade: 2 }]);
            this.props.history.replace(baseConfig.routeUrl + `/assessormanage`);
        }
    }

    // 打开弹框 一
    openTipsOne = () => {
        this.setState({ tipsOneModalVisible: true });
    }

    // 打开弹框 二
    openTipsTwo = () => {
        this.setState({ tipsTwoModalVisible: true });
    }

    // 打开弹框 三
    openTipsThree = () => {
        this.setState({ tipsThreeModalVisible: true });
    }

    // 关闭弹框 一
    closeTipsOne = () => {
        this.setState({ tipsOneModalVisible: false });
    }

    // 关闭弹框 二
    closeTipsTwo = () => {
        const iframeDom = this.iframeRef.current;
        iframeDom.contentWindow.postMessage({
            from: 'createAssess',
            type: 'closeTips'
        }, '*');
        // console.log(this.state.courseId.toString(), this.state.tipsModalType, this.state.tipsTwoModalVisible);
        if (this.checkCourseId(this.state.courseId.toString()) && this.state.tipsModalType == 'gamebreak' && this.state.tipsTwoModalVisible == true) {
            this.startAssessCall(this.state.assessName3D, this.state.courseId.toString(), this.state.assessUrl3D, this.state.reportType);
        }
        else {
            this.setState({ tipsTwoModalVisible: false });
        }
    }

    // 关闭弹框 三
    closeTipsThree = () => {
        this.setState({ tipsThreeModalVisible: false });
        const iframeDom = this.iframeRef.current;
        iframeDom.contentWindow.postMessage({
            from: 'createAssess',
            type: 'closeTips'
        }, '*');
    }

    // 充值弹框 确认
    rechargeOk = () => {
        this.props.replace([{ path: '/usercenter', name: '用户中心', grade: 1 }, { path: '/accountrecharge', name: '账户充值', grade: 2 }]);
        this.props.history.push(baseConfig.routeUrl + `/accountrecharge`);
    }

    // 充值弹框 关闭
    rechargeClose = () => {
        this.setState({ rechargeModalVisible: false, rechargeModalMsg: '' });
    }

    // 下载脑波助手
    culinkDownload = () => {
        window.open(this.state.tipsThreeDownloadUrl, '_blank');
    }

    refresh = () => {
        this.courseItem();
    }

    /**
     * 倒计时
     */
    countdownTimer = (timeNumber) => {

        // 方案一
        clearInterval(this.state.assessTimerId)
        const iframeDom = this.iframeRef.current

        let tempAssessTimerId = setInterval(() => {
            timeNumber -= 1

            if (timeNumber <= 0) {
                clearInterval(tempAssessTimerId)
            }

            if (timeNumber >= 0) {
                this.setState({ assessRemainderText: formatHourMinuteSecond(timeNumber) })
            }

            iframeDom.contentWindow.postMessage({
                from: 'createAssess',
                type: 'remainder',
                value: timeNumber
            }, '*')
        }, 1000)

        this.setState({ assessTimerId: tempAssessTimerId, assessRemainder: timeNumber, assessRemainderVisible: true })

        // 方案二
        // 系统时间戳
        // let startTimeStamp = new Date().getTime();
        // this.setState({ startTimeStamp: startTimeStamp, totalTime: timeNumber * 1000, assessRemainderVisible: true });
        // this.startCountdown();
    }

    startCountdown = () => {
        const iframeDom = this.iframeRef.current
        const now = new Date().getTime();
        // console.log('现在:' + now)
        const elapsed = now - this.state.startTimeStamp;
        // console.log('消耗:' + elapsed)
        const remaining = this.state.totalTime - elapsed;
        // console.log('剩余：' + remaining)
        const remainingComputed = Math.round(remaining / 1000);
        if (remaining <= 0) {
            this.setState({ assessRemainderText: formatHourMinuteSecond(0) });
            remainingComputed = 0;
        }
        else {
            let timeoutId = setTimeout(this.startCountdown, 200);
            this.setState({ assessRemainderText: formatHourMinuteSecond(remainingComputed), timeoutId: timeoutId, assessRemainder: remainingComputed });
            // console.log('倒计时：' + formatHourMinuteSecond(remainingComputed))
        }

        iframeDom.contentWindow.postMessage({
            from: 'createAssess',
            type: 'remainder',
            value: remainingComputed
        }, '*')
    }

    render() {
        const { assessRemainderVisible, assessRemainderText, assessUseToken, assessToken, courseId, userId } = this.state
        let { tipsOneModalVisible } = this.state

        let iframeSrc = ''
        if (this.iframeUrl == 'about:blank') {
            iframeSrc = 'about:blank'
        }
        else {
            if (assessUseToken) {
                iframeSrc = this.iframeUrl + '&course_id=' + courseId + '&user_id=' + userId + '&token=' + assessToken
            }
            else {
                iframeSrc = this.iframeUrl + '&course_id=' + courseId + '&user_id=' + userId
            }
        }

        const contentLoading = this.state.cocosLoading && this.state.unityLoading ? 'none' : 'block'
        if (contentLoading == 'block') {
            tipsOneModalVisible = false
        }

        const assessRemainderTextVisible = assessRemainderVisible ? 'block' : 'none'

        return (
            <Card title="" className='createAssess'>

                {/* 测评项目 */}
                {/* {[...this.assessItems]} */}
                {/* <Button type='default' size={'large'} onClick={this.refresh} >刷新</Button> */}
                {this.state.tabsDom}

                {/* 停止测评 */}
                <Modal
                    className='modals modals-noButton CreateAssess-recharge-modal'
                    title="提示"
                    visible={this.state.rechargeModalVisible}
                    // onOk={this.rechargeOk}
                    onCancel={this.rechargeClose}
                    maskClosable={false}
                >
                    <p className='modalText'>{this.state.rechargeModalMsg}</p>
                    <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '20px' }}>
                        <Button type='default' size={'large'} onClick={this.rechargeClose} >知道了</Button>
                        <Button type='primary' size={'large'} onClick={this.rechargeOk} style={{ marginLeft: '50px' }}>账户充值</Button>
                    </div>
                </Modal>

                {/* 停止测评 */}
                <Modal
                    className='modals CreateAssess-stop-modal'
                    title="停止测评"
                    visible={this.state.stopModalVisible}
                    onOk={this.stopOk}
                    onCancel={this.stopClose}
                    maskClosable={false}
                >
                    <p className='modalText'>{this.state.stopModalText}</p>
                </Modal>

                {/* 测评结束 */}
                <Modal
                    className='modals CreateAssess-end-evaluate '
                    title="测评结束"
                    visible={this.state.endModalVisible}
                    onCancel={this.evaluateClose}
                    maskClosable={false}
                >
                    {
                        this.state.isStuType && <>
                            <p className='modalText'>本次测评已结束</p>
                            <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '20px' }}>
                                <Button type='default' size={'large'} shape="round" onClick={this.evaluateClose} >关闭</Button>
                            </div>
                        </>
                    }
                    {
                        !this.state.isStuType && <>
                            <p className='modalText'>本次测评已结束，您可以：</p>
                            <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '20px' }}>
                                <Button type='default' size={'large'} shape="round" onClick={this.jumpReports} >查看报告</Button>
                                <Button type='default' size={'large'} shape="round" onClick={this.jumpAssessor} style={{ marginLeft: '50px' }}>返回列表</Button>
                            </div>
                        </>
                    }
                    {/* <p className='modalText'>本次测评已结束，您可以：</p>
                    <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '20px' }}>
                        <Button type='default' size={'large'} shape="round" onClick={this.jumpReports} >查看报告</Button>
                        <Button type='default' size={'large'} shape="round" onClick={this.jumpAssessor} style={{ marginLeft: '50px' }}>返回列表</Button>
                    </div> */}
                </Modal>

                {/* 测评 */}
                <Modal
                    className='modals CreateAssess-main-modal'
                    title={this.state.itemTitle}
                    visible={this.state.mainModalVisible}
                    onCancel={this.assessClose}
                    maskClosable={false}
                    width={this.state.mainModalWidth}
                    height={this.state.mainModalHeight}
                >
                    <div className='iframeContent' >
                        <div className='loading' style={{ display: contentLoading }}>
                            <Spin size="large" className='loadingSpin' tip="正在加载中..." />
                        </div>
                        <div className='countdownText' style={{ display: assessRemainderTextVisible }}>{assessRemainderText}</div>
                        {/* 2025-06-25 */}
                        <iframe ref={this.iframeRef} allowfullscreen="true" style={{ width: this.state.mainModalWidth, height: this.state.iframeHeight }} src={iframeSrc} title='PenguinTestmain'></iframe>
                    </div>
                </Modal>

                {/* 提示-只有文本 */}
                <Modal
                    className='modals CreateAssess-tipsOne-modal'
                    visible={tipsOneModalVisible}
                    maskClosable={false}
                    onCancel={this.closeTipsOne}
                    title='提示'
                >
                    <p className='modalText'>{this.state.tipsText}</p>
                </Modal>

                {/* 提示-文本、关闭 */}
                <Modal
                    className='modals CreateAssess-tipsTwo-modal'
                    visible={this.state.tipsTwoModalVisible}
                    onCancel={this.closeTipsTwo}
                    maskClosable={false}
                    title={this.state.tipsTitle}
                >
                    <p className='modalText'>{this.state.tipsText}</p>
                    <Button type='primary' htmlType='button' onClick={this.closeTipsTwo}>确定</Button>
                </Modal>

                {/* 提示-确定、下载、关闭 */}
                <Modal
                    className='modals CreateAssess-tipsThree-modal'
                    visible={this.state.tipsThreeModalVisible}
                    onCancel={this.closeTipsThree}
                    maskClosable={false}
                    title={this.state.tipsTitle}
                >
                    <p className='modalText' style={{ margin: '0 0 40px 0' }}>{this.state.tipsText}</p>
                    <Button htmlType='button' onClick={this.closeTipsThree}>确定</Button>
                    <Button htmlType='button' onClick={this.culinkDownload} style={{ marginLeft: '30px' }} type='primary'>下载</Button>
                </Modal>
            </Card>
        )
    }
}

// 容器组件
const mapStateToProps = (state) => {
    return { breadcrumberData: state.breadcrumber, loginData: state.login }
}

const mapDispatchToProps = (dispatch) => {
    return {
        add: (data) => { dispatch(addBreadcrumber(data)) },
        replace: (data) => { dispatch(replaceBreadcrumber(data)) },
        reduce: (data) => { dispatch(reduceBreadcrumber(data)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAssess)